import { mount } from './controller';

function initialize() {
    document.querySelectorAll<HTMLElement>('.jgb-layout-preview [data-jgb-lp-root]').forEach(mount);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
else initialize();
